import shape from "../../assets/img/shapes/star-shape-01.webp";


const StarShape01 = () => {

    return (
        <div className="rmdr-star-shape-01">
            <img src={shape} alt="rmdr-star-shape-01" loading="lazy" width={54} height={54} />
        </div>
    )

}

export default StarShape01;
